import { render } from "./EchecGame.vue?vue&type=template&id=88216012&ts=true"
import script from "./EchecGame.vue?vue&type=script&lang=ts"
export * from "./EchecGame.vue?vue&type=script&lang=ts"

import "./EchecGame.vue?vue&type=style&index=0&id=88216012&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__